import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {Input, ListGroup} from "reactstrap";
import AsyncSelect from 'react-select/async';
import api from "../../../../../api";

const loadOptions = (inputValue, callback) => {
  setTimeout(() => {
    callback(filterColors(inputValue));
  }, 1000);
};

class PresentationTypeLibrary extends Component {

  constructor(props) {
    super(props);

    this.state = {
      searchTimeout: null,
    };

    this.fetchOptions = this.fetchOptions.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  fetchOptions(inputValue, callback){
    clearTimeout(this.state.searchTimeout);

    this.setState({
      searchTimeout: setTimeout(() => {
        api.question.post.searchLibraryValues(this.props.question.id, inputValue)
        .then(data => {
          // let pattern = 'd.value + " ("+d.col1+")"';
          let pattern = this.props.question.libraryValuePattern || 'd.value';
          let func = new Function("return " + "function (d) { return " + pattern + " }")();

          callback(data.map(d => {
            return {
              label: func(d),
              value: d.value,
            };
          }));
        });
      }, 600)
    });
  }

  onChange(option){
    this.props.onChange({
      target: {
        value: option.value
      }
    });
  }

  validate(){
    let validate = {
      valid: true,
      errors: []
    };

    return validate;
  }

  render() {
    const {value} = this.props;

    return <AsyncSelect
      placeholder={this.props.intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})}
      cacheOptions
      loadOptions={this.fetchOptions}
      defaultOptions
      onChange={this.onChange}
      value={value && {
        label: value,
        value: value,
      }}
    />;
  }
}

PresentationTypeLibrary.propTypes = {
  question: PropTypes.shape({
    libraryValuePattern: PropTypes.string,
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default connect(null, null, null, {withRef: true})(PresentationTypeLibrary);